import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import TopScroller from './TopScroller';
import Plotly from './Plotly';
import './ResultsTable.css';
export function parseValue(value, withStringEscaping = false) {
    if (typeof value === 'boolean') {
        return String(value).toUpperCase();
    }
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }
    // it is important to render truly "strings" here, no exclude user's misunderstanding
    // when he compares the result
    if (withStringEscaping) {
        if (typeof value === 'number') {
            return Number(value);
        }
        if (typeof value === 'string') {
            return `"${value}"`;
        }
    }
    return value;
}
function ResultsTable({ results, isSubmission = false, wrongRows = undefined, className = '', }) {
    var _a, _b;
    const containerClassName = `ResultsTable__container ${className}`;
    const tableRef = useRef(null);
    const bottomScrollRef = useRef(null);
    const topScrollRef = useRef(null);
    const onScroll = useCallback(() => { var _a; return (_a = topScrollRef.current) === null || _a === void 0 ? void 0 : _a.onScroll(); }, []);
    if (typeof results === 'number' || typeof results === 'string') {
        return _jsx("div", { className: containerClassName, children: results });
    }
    if (typeof results !== 'boolean') {
        if ('image' in results && results.image) {
            return (_jsx("img", { src: `data:image/png;base64, ${results.image}`, alt: "Rendered Chart" }));
        }
        if ('plotly' in results && ((_a = results.plotly) === null || _a === void 0 ? void 0 : _a.data) && ((_b = results.plotly) === null || _b === void 0 ? void 0 : _b.layout)) {
            return (_jsx(Plotly, { data: results.plotly.data, layout: results.plotly.layout }));
        }
    }
    // Assume results is not a TableData but a general object, if 'data' key is not in it
    if (typeof results === 'boolean' || !('data' in results)) {
        return _jsx("div", { className: containerClassName, children: JSON.stringify(results) });
    }
    const rowClassName = (rowIndex) => {
        if (!isSubmission)
            return '';
        if (wrongRows === null || wrongRows === void 0 ? void 0 : wrongRows.includes(rowIndex))
            return 'ResultsTable__row--wrong';
        return 'ResultsTable__row--correct';
    };
    return (_jsxs("div", { children: [_jsx(TopScroller, { widthElRef: tableRef, scrollElRef: bottomScrollRef, ref: topScrollRef }), _jsx("div", { className: containerClassName, ref: bottomScrollRef, onScroll: onScroll, children: _jsxs("table", { className: "ResultsTable__table", ref: tableRef, children: [_jsx("thead", { children: _jsx("tr", { className: "ResultsTable__header-row", children: results.columns.map((col) => (_jsx("th", { className: "ResultsTable__header-cell", children: col }, `${col}-header`))) }) }), _jsx("tbody", { children: results &&
                                (results === null || results === void 0 ? void 0 : results.data.map((row, i) => (_jsx("tr", { className: `ResultsTable__row ${rowClassName(i)}`, children: row.map((cell, j) => (_jsx("td", { className: "ResultsTable__cell", children: parseValue(cell, isSubmission && wrongRows !== undefined) }, `cell-${i}-${parseValue(cell)}-${j}`))) }, `row-${i}-${row.join()}`)))) })] }) })] }));
}
export default ResultsTable;
//# sourceMappingURL=ResultsTable.js.map